var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useEffect } from 'react';
import { motion } from "framer-motion";
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import classNames from 'classnames';
export default function stripMixedSizeCarousel(props) {
    var fields = props.fields;
    //console.log('stripMixedSizeCarousel', props);
    var splideId = "mixedsizecarousel_" + fields.mixedsizecarouselID;
    var splideRef = useRef(null);
    useEffect(function () {
        var lightbox = new PhotoSwipeLightbox({
            gallery: '#' + splideId,
            children: '.splide__slide a',
            pswpModule: PhotoSwipe,
        });
        lightbox.on('uiRegister', function () {
            lightbox.pswp.ui.registerElement({
                name: 'spa-mixed-size-carousel-caption',
                order: 9,
                isButton: false,
                appendTo: 'root',
                html: 'Caption text',
                onInit: function (el, pswp) {
                    lightbox.pswp.on('change', function () {
                        var currSlideElement = lightbox.pswp.currSlide.data.element;
                        var captionHTML = '';
                        if (currSlideElement) {
                            var caption = currSlideElement.querySelector('.text-content');
                            if (caption) {
                                // get caption from element with class hidden-caption-content
                                captionHTML = '<div class="inner">' + caption.innerHTML + '</div>';
                            }
                        }
                        el.innerHTML = captionHTML || '';
                    });
                }
            });
        });
        lightbox.init();
        return function () {
            lightbox.destroy();
            lightbox = null;
        };
    }, []);
    return (React.createElement(motion.div, __assign({ initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" } }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement(Splide, { id: splideId, hasTrack: false, "aria-label": fields.name, options: {
                rewind: true,
                autoWidth: true,
                gap: 10,
                arrows: false,
                pagination: false
                //type: 'loop',
            }, ref: splideRef, className: "strip spa-mixed-size-carousel splide text-moss "
                + fields.backgroundColor
                + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
                + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
                + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
                + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
                + (fields.textColor ? (" text-color-" + fields.textColor) : "") },
            React.createElement(SplideTrack, null, (props.children || []).map(function (x) { return React.createElement(MixedSizeCarouselItem, __assign({ key: x.id }, x)); })))));
}
var MixedSizeCarouselItem = function (props) {
    var fields = props.fields;
    return React.createElement(SplideSlide, { className: "mixed-size-carousel-item " + "content-position-".concat(fields.textContentPosition) },
        React.createElement("a", { href: fields.largeImage, "data-pswp-width": fields.largeImage_width, "data-pswp-height": fields.largeImage_height, key: props.id, target: "_blank", rel: "noreferrer" },
            React.createElement("div", { className: classNames({ "inner": true, 'with-overlay': fields.addOverlay }) },
                React.createElement("img", { src: fields.image, alt: fields.image_description, title: fields.image_description, width: fields.image_width, height: fields.image_height }),
                React.createElement("img", { src: fields.largeImage, alt: fields.largeImage_description, title: fields.largeImage_description, style: { display: 'none' } })),
            (fields.title || fields.subtitle) &&
                React.createElement("div", { className: 'text-content' },
                    fields.title && React.createElement("h5", { className: "title", dangerouslySetInnerHTML: { __html: fields.title } }),
                    fields.subtitle && React.createElement("div", { className: "subtitle", dangerouslySetInnerHTML: { __html: fields.subtitle } }))));
};
